var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slide-title",class:{'slide-title--right': _vm.slide.frontSlide }},[_c('h1',[(_vm.showSlideShow && _vm.slide.link)?_c('cmslink',{attrs:{"link":_vm.slide}}):_c('span',[_vm._v(_vm._s(_vm.slide.title))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }